import { lazy } from "react";

const Home = lazy(() => import("./component/baatein/Home"));
const Baateinabout = lazy(() => import("./component/baatein/baateinabout"));
const Baateintopbar = lazy(() => import("./component/baatein/baateintopbar"));
const RefundPolicy = lazy(() => import("./component/baatein/RefundPolicy"));
const PrivacyPolicy = lazy(() => import("./component/baatein/PrivacyPolicy"));
const Term = lazy(() => import("./component/baatein/Term"));
const ChildSafety = lazy(() => import("./component/baatein/ChildSafety"));
const DeleteDetails = lazy(() => import("./component/baatein/DeleteDetails"));
const WalletBalance = lazy(
  () => import("./component/baatein/Transaction/WalletBalance")
);
const Payment = lazy(() => import("./component/baatein/Transaction/Payment"));
const Successfully = lazy(
  () => import("./component/baatein/Transaction/Successfully")
);
const PlanSection = lazy(
  () => import("./component/baatein/Price Plan/PlanSection")
);
const Contact = lazy(() => import("./component/baatein/Contact"));
const ShippingPolicy = lazy(() => import("./component/baatein/ShippingPolicy"));
const PlayStore = lazy(() => import("./component/PlayStore"));
const Credentials = lazy(() => import("./component/Credentials/Credentials"));
const CredentialsForm = lazy(
  () => import("./component/Credentials/CredentialsForm")
);
const CredentialsShow = lazy(
  () => import("./component/Credentials/CredentialsShow")
);
const Languagetabledata = lazy(
  () => import("./component/languagetable/Languagetabledata")
);
const LanguageEdit = lazy(
  () => import("./component/languagetable/Language Edit/LanguageEdit")
);
const Audio = lazy(() => import("./component/Audio Type/audio"));
const Recharge = lazy(() => import("./component/Recharge/recharge"));
const RechargeBody = lazy(() => import("./component/Recharge/rechargeBody"));
const RechargeEdit = lazy(
  () => import("./component/Recharge/Recharge Edit/rechargeedit")
);
const Login = lazy(() => import("./component/Auth/login"));
const Password = lazy(() => import("./component/Auth/Password"));
const Consultant = lazy(() => import("./component/Consultant/Consultant"));
const ConsultantEdit = lazy(
  () => import("./component/Consultant/ConsultantEdit/ConsultantEdit")
);
const Consultantdata = lazy(
  () => import("./component/Consultant/Consultantdata")
);
const ConsultantBalance = lazy(
  () => import("./component/Consultant/ConsultantBalance")
);
const Usercreate = lazy(() => import("./component/UserData/user"));
const UserTableBody = lazy(() => import("./component/UserData/UserTablebody"));
const UserShow = lazy(() => import("./component/User/UserShow"));
const Expertise = lazy(() => import("./component/Service&Expertise/Expertise"));
const ExpertiseEdit = lazy(
  () => import("./component/Service&Expertise/Expertise Edit/expertiseedit")
);
const Service = lazy(() => import("./component/Service&Expertise/service"));
const Serviceedit = lazy(() => import("./component/ServiceEdit/serviceedit"));
const Expert = lazy(() => import("./component/Service&Expertise/expert"));
const Servicebody = lazy(
  () => import("./component/Service&Expertise/ServiceTable")
);
const Language = lazy(() => import("./component/language/language"));
const BankAccount = lazy(() => import("./component/Bank Account/BankAccount"));
const SubAdmin = lazy(() => import("./component/SubAdmin/SubAdmin"));
const SubAdminTable = lazy(() => import("./component/SubAdmin/SubAdminTable"));
const Sidebar = lazy(() => import("./component/Global/sidebar"));
import { Navigate } from "react-router-dom";
import { ProtectedRoute } from "@techveda/react-auth";
import AdminTable from "./component/SuperAdmin/AdminTable";
import Admin from "./component/SuperAdmin/Admin";
import SuperEdit from "./component/SuperAdmin/SuperEdit/SuperEdit";
import SubAdminEdit from "./component/SubAdmin/SubAdminEdit/SubAdminEdit";
import Verify from "./component/Consultant/Verify";
import Dashboard from "./component/Dashboard/Dashboard";
import Analytics from "./component/Analytics/Analytics";
import AnalyticsDetail from "./component/Analytics/AnalyticsDetail";
import Transaction from "./component/Transaction/Transaction";
import CallLogs from "./component/CallLogs/CallLogs";
import CallRecordings from "./component/CallRecordings/CallRecordings";
import CallReport from "./component/CallReport/CallReport";
import ConsultantsPayout from "./component/ConsultantsPayout/ConsultantsPayout";
import Subscription from "./component/Subscription/Subscription";
import SubscriptionBody from "./component/Subscription/SubscriptionBody";
import SubscriptionEdit from "./component/Subscription/SubscriptionEdit/SubscriptionEdit";

// const permission=JSON.parse(localStorage.getItem('data'))?.permissions || []

const wrapWithProtection = (
  element,
  role = null,
  permission,
  redirectTo = "/"
) => {
  if (!role) return element;
  return (
    <ProtectedRoute entity={role} redirectTo={redirectTo} permission={permission}>
      {element}
     </ProtectedRoute>
  );
};

export const RoutesArray = [
  // 🌐 Public Routes

  {
    path: "/credentials",
    element: <Navigate to="/credentials/login" />,
  },
  {
    path: "/",
    element: <Baateintopbar />,
    children: [
      {
        index: true,
        title: "Baatein - Home",
        description: "Welcome to Baatein",
        element: <Home />,
      },
      {
        path: "about",
        title: "Baatein - About",
        description: "Learn more about Baatein",
        element: <Baateinabout />,
      },
      {
        path: "refund_policy",
        title: "Baatein - Refund Policy",
        description: "Understand our refund policy",
        element: <RefundPolicy />,
      },
      {
        path: "privacy_policy",
        title: "Baatein - Privacy Policy",
        description: "Read our privacy policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "terms_and_conditions",
        title: "Baatein - Terms and Conditions",
        description: "Read our terms and conditions",
        element: <Term />,
      },
      {
        path: "child_safety",
        title: "Baatein - Child Safety",
        description: "Learn about child safety",
        element: <ChildSafety />,
      },
      {
        path: "delete_account",
        title: "Baatein - Delete Account",
        description: "Delete your account",
        element: <DeleteDetails />,
      },
      {
        path: "pricing_plan",
        title: "Baatein - Pricing Plan",
        description: "View our pricing plans",
        element: <PlanSection />,
      },
      {
        path: "contact_us",
        title: "Baatein - Contact Us",
        description: "Get in touch with us",
        element: <Contact />,
      },
      {
        path: "shipping_policy",
        title: "Baatein - Shipping Policy",
        description: "Read our shipping policy",
        element: <ShippingPolicy />,
      },
      {
        path: "app/*",
        title: "Baatein - Play Store",
        description: "Visit our Play Store page",
        element: <PlayStore />,
      },
      {
        path: "my_wallet",
        title: "Baatein - My Wallet",
        description: "View your wallet balance",
        element: <WalletBalance />,
      },
      {
        path: "payment",
        title: "Baatein - Payment",
        description: "Make a payment",
        element: <Payment />,
      },
      {
        path: "payment-success",
        title: "Baatein - Payment Success",
        description: "Payment was successful",
        element: <Successfully />,
      },
    ],
  },
  {
    path: "credentials/login",
    title: "Baatein - Login",
    description: "Login to your account",
    element: <Login />,
  },
  {
    path: "credentials/password",
    title: "Baatein - Forgot Password",
    description: "Reset your password",
    element: <Password />,
  },

  {
    path: "/admin",
    element: <Navigate to="/admin/consultant" />,
  },
  // 🔐 Admin Protected Routes
  {
    path: "/admin",
    element: wrapWithProtection(<Sidebar />, [
      "admin",
      "super_admin",
      "sub_admin",
    ]),
    children: [
       {
        path: "dashboard",
        title: "Dashboard",
        description: "Welcome to Macho, Admin Panel",
        element: wrapWithProtection(
          <Dashboard />,
          ["super_admin"],
          "DASHBOARD",
        ),
      },
      {
        path: "analytics",
        title: "Platform Analytics",
        description: "Platform Analytics Dashboard",
        element: wrapWithProtection(
          <Analytics />,
          ["super_admin", "admin", "sub_admin"],
          "ANALYTICS",
        ),
      },
      {
        path: "analytics/detail",
        title: "Analytics Detail",
        description: "Analytics Detail List",
        element: wrapWithProtection(
          <AnalyticsDetail />,
          ["super_admin", "admin", "sub_admin"],
          "ANALYTICS",
        ),
      },
      {
        path: "consultant",
        title: "Consultants",
        description: "Welcome to Baatein, Admin Panel",
        element: wrapWithProtection(
          <Consultant />,
          ["admin", "super_admin", "sub_admin"],
          "CONSULTANT"
        ),
      },
      {
        path: "consultant/create_consultant",
        title: "Consultant Creating",
        description: "Consultant Creation Page",
        element: wrapWithProtection(
          <Consultantdata />,
          ["admin", "super_admin", "sub_admin"],
          "CONSULTANT"
        ),
      },
      {
        path: "consultant/consultant_details",
        title: "Consultants Details",
        description: "Consultant Details Page",
        element: wrapWithProtection(
          <ConsultantEdit />,
          ["admin", "super_admin", "sub_admin"],
          "CONSULTANT"
        ),
      },
      {
        path: "consultant/verify_consultant",
        title: "Consultant",
        description: "Consultant Verification",
        element: wrapWithProtection(
          <Verify />,
          ["admin", "super_admin", "sub_admin"],
          "CONSULTANT"
        ),
      },
      {
        path: "user",
        title: "Users",
        description: "Users Page",
        element: wrapWithProtection(
          <UserTableBody />,
          ["admin", "super_admin", "sub_admin"],
          "USER"
        ),
      },
      {
        path: "user/create_user",
        title: "Creating User",
        description: "User Creation Page",
        element: wrapWithProtection(
          <Usercreate />,
          ["admin", "super_admin", "sub_admin"],
          "USER"
        ),
      },
      {
        path: "user/user_detail",
        title: "User Details",
        description: "User Details Page",
        element: wrapWithProtection(
          <UserShow />,
          ["admin", "super_admin", "sub_admin"],
          "USER"
        ),
      },
      {
        path: "language",
        title: "Languages",
        description: "Languages Page",
        element: wrapWithProtection(
          <Languagetabledata />,
          ["admin", "super_admin", "sub_admin"],
          "LANGUAGE"
        ),
      },
      {
        path: "language/create_language",
        title: "Creating Language",
        description: "Language Creation Page",
        element: wrapWithProtection(
          <Language />,
          ["admin", "super_admin", "sub_admin"],
          "LANGUAGE"
        ),
      },
      {
        path: "language/language_detail",
        title: "Language Details",
        description: "Language Details Page",
        element: wrapWithProtection(
          <LanguageEdit />,
          ["admin", "super_admin", "sub_admin"],
          "LANGUAGE"
        ),
      },
      {
        path: "service",
        title: "Services",
        description: "Services Page",
        element: wrapWithProtection(
          <Servicebody />,
          ["admin", "super_admin", "sub_admin"],
          "SERVICE"
        ),
      },
      {
        path: "service/create_service",
        title: "Creating Service",
        description: "Service Creation Page",
        element: wrapWithProtection(
          <Service />,
          ["admin", "super_admin", "sub_admin"],
          "SERVICE"
        ),
      },
      {
        path: "service/service_detail",
        title: "Service Details",
        description: "Service Details Page",
        element: wrapWithProtection(
          <Serviceedit />,
          ["admin", "super_admin", "sub_admin"],
          "SERVICE"
        ),
      },
      {
        path: "expertise",
        title: "Expertise",
        description: "Expertise Page",
        element: wrapWithProtection(
          <Expert />,
          ["admin", "super_admin", "sub_admin"],
          "EXPERTISE"
        ),
      },
      {
        path: "expertise/new_expertise",
        title: "Creating Expertise",
        description: "Expertise Creation Page",
        element: wrapWithProtection(
          <Expertise />,
          ["admin", "super_admin", "sub_admin"],
          "EXPERTISE"
        ),
      },
      {
        path: "expertise/expertise_detail",
        title: "Expertise Details",
        description: "Expertise Details Page",
        element: wrapWithProtection(
          <ExpertiseEdit />,
          ["admin", "super_admin", "sub_admin"],
          "EXPERTISE"
        ),
      },
      {
        path: "recharge",
        title: "Recharge",
        description: "Recharge Page",
        element: wrapWithProtection(
          <Recharge />,
          ["admin", "super_admin", "sub_admin"],
          "RECHARGE"
        ),
      },
      {
        path: "recharge/create_recharge",
        title: "Creating Recharge",
        description: "Recharge Creation Page",
        element: wrapWithProtection(
          <RechargeBody />,
          ["admin", "super_admin", "sub_admin"],
          "RECHARGE"
        ),
      },
      {
        path: "recharge/recharge_detail",
        title: "Recharge Details",
        description: "Recharge Details Page",
        element: wrapWithProtection(
          <RechargeEdit />,
          ["admin", "super_admin", "sub_admin"],
          "RECHARGE"
        ),
      },
        {
        path: "subscription",
        title: "Subscription",
        description: "Subscription Page",
        element: wrapWithProtection(
          <Subscription />,
          ["admin", "super_admin", "sub_admin"],
          "RECHARGE"
        ),
      },
      {
        path: "subscription/create_subscription",
        title: "Creating Subscription",
        description: "Subscription Creation Page",
        element: wrapWithProtection(
          <SubscriptionBody />,
          ["admin", "super_admin", "sub_admin"],
          "RECHARGE"
        ),
      },
      {
        path: "subscription/subscription_detail",
        title: "Subscription Details",
        description: "Subscription Details Page",
        element: wrapWithProtection(
          <SubscriptionEdit />,
          ["admin", "super_admin", "sub_admin"],
          "RECHARGE"
        ),
      },
      {
        path: "consultant_recording",
        title: "Consultant Recording",
        description: "Consultant Recording Page",
        element: wrapWithProtection(
          <Audio />,
          ["admin", "super_admin", "sub_admin"],
          "CONSULTANT_RECORDINGS"
        ),
      },
      {
        path: "call_logs",
        title: "Call Logs",
        description: "Call Logs Page",
        element: wrapWithProtection(
          <CallLogs />,
          ["admin", "super_admin"],
          "CALL_LOGS"
        ),
      },
      {
        path: "call_recordings",
        title: "Call Recordings",
        description: "Call Recordings Page",
        element: wrapWithProtection(
          <CallRecordings />,
          ["admin", "super_admin"],
          "CALL_RECORDINGS"
        ),
      },
      {
        path: "call_report",
        title: "Call Report",
        description: "Daily Call Report Page",
        element: wrapWithProtection(
          <CallReport />,
          ["admin", "super_admin"],
          "CALL_REPORT"
        ),
      },
      {
        path: "consultants_payout",
        title: "Consultants Payout",
        description: "Consultants with balance for payout",
        element: wrapWithProtection(
          <ConsultantsPayout />,
          ["admin", "super_admin"],
          "CONSULTANTS_PAYOUT"
        ),
      },
      {
        path: "credentials",
        title: "Super Admin",
        description: "Super Admin Page",
        element: wrapWithProtection(
          <Credentials />,
          ["admin", "super_admin", "sub_admin"],
          "CREDENTIALS"
        ),
      },
      {
        path: "credentials/create_credentials",
        title: "Creating Credentials",
        description: "Credentials Creation Page",
        element: wrapWithProtection(
          <CredentialsForm />,
          ["admin", "super_admin", "sub_admin"],
          "CREDENTIALS"
        ),
      },
      {
        path: "credentials/credentials_details",
        title: "Credentials Details",
        description: "Credentials Details Page",
        element: wrapWithProtection(
          <CredentialsShow />,
          ["admin", "super_admin", "sub_admin"],
          "CREDENTIALS"
        ),
      },
      // {
      //   path: "transfer_funds",
      //   title: "Transfer Funds",
      //   description: "Transfer Funds Page",
      //   element: wrapWithProtection(
      //     <ConsultantBalance />,
      //     ["admin", "super_admin", "sub_admin"],
      //     "TRANSFER_FUNDS"
      //   ),
      // },
      {
       path: "transaction",
       title : "Transaction",
       description : "Transaction Page",
       element : wrapWithProtection(
         <Transaction/>,
         [ "super_admin","admin"],
         "TRANSACTION"
       )
      },
      {
        path: "bank_account",
        title: "Bank Account",
        description: "Bank Account Page",
        element: wrapWithProtection(
          <BankAccount />,
          ["admin", "super_admin", "sub_admin"],
          "BANK_ACCOUNTS"
        ),
      },
      {
        path: "sub_admin",
        title: "Sub Admin",
        description: "Sub Admin Page",
        element: wrapWithProtection(
          <SubAdminTable />,
          ["admin", "super_admin"],
          "SUB_ADMIN"
        ),
      },
      {
        path: "sub_admin/create_sub_admin",
        title: "Creating Sub Admin",
        description: "Sub Admin Creation Page",
        element: wrapWithProtection(
          <SubAdmin />,
          ["admin", "super_admin"],
          "SUB_ADMIN"
        ),
      },
      {
        path: "sub_admin/sub_admin_details",
        title: "Details of Sub Admin",
        description: "Sub Admin Details",
        element: wrapWithProtection(
          <SubAdminEdit />,
          ["admin", "super_admin"],
          "SUB_ADMIN"
        ),
      },
      {
        path: "super_admin",
        title: "Super Admins",
        description: "Manage all super admin accounts",
        element: wrapWithProtection(<AdminTable />, ["super_admin"], "ADMIN"),
      },
      {
        path: "super_admin/create_super_admin",
        title: "Create Super Admin",
        description: "Create a new super admin account",
        element: wrapWithProtection(<Admin />, ["super_admin"], "ADMIN"),
      },
      {
        path: "super_admin/admin_details",
        title: "Super Admin Details",
        description: "View or edit details of a super admin",
        element: wrapWithProtection(<SuperEdit />, ["super_admin"], "ADMIN"),
      },
      {
        path: "*",
        element: <Navigate to="/" />,
      },
    ],
  },
  // {
  //   path: '/unauthorized',
  //   element : <Navigate to='/'/>
  // },

  // 🔁 Catch-all route

  {
    path: "*",
    element: <Navigate to="/" />,
  },
];